export default {
    currentPicture() {
        return this.$store?.state?.session?.user?.photo_images?.user_default
    }
}
